import React from 'react'
import Armoirecontainer from '../../section/Armoirecontainer/Armoirecontainer'

const Armoire = () => {
  return (
    <div><Armoirecontainer/></div>
  )
}

export default Armoire